var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"title":"查看消息"},on:{"click":_vm.clickNotifications}},[_c('a-badge',{attrs:{"dot":_vm.showDot}},[_c('a-icon',{staticClass:"alain-pro__nav-item-icon",attrs:{"type":"bell"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }